import ActionButton from 'components/ActionButton';
import DashboardItem from 'components/Dashboard/DashboardItem';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { DASHBOARD_ITEMS } from 'utils';

const DashboardPage = (props) => {
  const { isOrdersListPage=false } = props;
  const [refresh, setRefresh] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(true);
  const [intervalId, setIntervalId] = useState<any>(false);

  function handleRefreshAll (){
    setLoading(true);
    const id = setInterval(()=>{
      setRefresh(_.random(100));
    },20000);
    setIntervalId(id);
    setTimeout(()=>{
      setLoading(false);
    }, 2000);
  }

  useEffect(()=>{
    handleRefreshAll();
    return clearInterval(intervalId);
  },[]);

  function handleHideShow(){
    setShow(!show);
    if(!show){
      clearInterval(intervalId);
    } 
  }

  function getDashBoardHeader() {
    return (
      <div className='d-flex justify-content-between mb-3'>
        <h1 className='m-0 text-dark' style={{ fontSize: '1.8rem' }}>{!isOrdersListPage ? 'Dashboard' : ''}</h1>
        <div className='d-flex'>
          <div>
            {show && <ActionButton
              active
              isLoading={loading}
              onClick={()=>setRefresh(_.random(100))}
              text={'Refresh All'}
              customClass='rounded'
            />}
          </div>
          {isOrdersListPage && <div className='ml-3'>
            <ActionButton
              active
              isLoading={false}
              onClick={handleHideShow}
              text={show ? 'Hide' : 'Show'}
              customClass='rounded'
            />
          </div>}
        </div>
      </div>
    );
  }

  function getDashBoardItems(){
    return DASHBOARD_ITEMS.map((item, index) => {
      const { action, itemHeaderName } = item;
      return <DashboardItem 
        key={index} 
        itemHeaderName={itemHeaderName}
        apiFunction={item.apiFunction} 
        isActionModal={action.isActionModal} 
        isActionRoute={action.isActionRoute}
        modalEntity={action.modalEntity} 
        route={action.route}
        refresh={refresh} 
        color={item.color}
        {...props} 
      />;
    });
  }

  return (
    <div className='mt-4'>
      {getDashBoardHeader()}
      {show ? <div className="row justify-content-center">
        {getDashBoardItems()}
      </div> : null}
    </div>
  );
};

export default DashboardPage;